// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KdnO+","price":"styles_price__R7YHF","oldPrice":"styles_oldPrice__S37UB","arrowRightIcon":"styles_arrowRightIcon__pYohI"};